import styled from "styled-components";
import { Type, DialogScroll } from "@ebscois/react-component-library";

export const HfcDialogTitle = styled(Type)`
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: 0;
    margin-left: 0;
  }
`;

export const HfcDialogContent = styled(DialogScroll)`
  margin: 0 ${({ theme }) => theme.space.xl} ${({ theme }) => theme.space.lg};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    min-height: 200px;
    margin: 0 ${({ theme }) => theme.space.md} ${({ theme }) => theme.space.md};
  }
`;
